import type { CheckTaskViewData, MoveTaskViewData, TaskViewData } from '@nova/core';
import type { YardTaskPayload } from './events';

/**
 * Builds the analytics event payload shared by "Created: Yard Task" and "Updated: Yard Task"
 * from task data.
 */
export function buildYardTaskAnalyticsEventContext(
  task: TaskViewData,
  context: { entryPoint: string }
): YardTaskPayload {
  const base: YardTaskPayload = {
    entry_point: context.entryPoint,
    yard_task_id: task.id ?? '',
    yard_task_type: task.type,
    yard_task_assignee: task.assignedTo?.id,
    yard_task_duedate: task.dueDateTime ?? undefined,
    yard_task_description: task.description ?? undefined,
    yard_task_tags: task.tags ?? [],
    // Attachments live on the shared base: move tasks carry them just like check tasks.
    has_attachment: Boolean(task.attachments?.length)
  };

  if (task.type === 'move') {
    const moveTask = task as MoveTaskViewData;
    return {
      ...base,
      asset_container_id: moveTask.assetContainer?.id,
      asset_container_code: moveTask.assetContainer?.code,
      origin_spot_id: moveTask.originSpot?.id,
      origin_spot_code: moveTask.originSpot?.code,
      destination_spot_id: moveTask.destinationSpot?.id,
      destination_spot_code: moveTask.destinationSpot?.code
    };
  }

  const checkTask = task as CheckTaskViewData;
  return {
    ...base,
    check_entity_name: checkTask.relatedEntity,
    check_entity_id: checkTask.relatedId ?? undefined,
    yard_task_category: checkTask.category,
    yard_task_checklist: checkTask.checklist ?? []
  };
}
